import { appendInitialSendMessages } from './appendInitialSendMessages'
import { markOpenAgentQuestionAnsweredInSnapshot } from './markOpenAgentQuestionAnsweredInSnapshot'
import { prepareSendTurn } from './prepareSendTurn'
import { beginSend } from './sendInFlightGuard'
import { startInitialAssistantTurn } from './startInitialAssistantTurn'

export function runPreparedSendTurn(m, p) {
  const { chatAbortRef, sendInFlightRef, setMessagesByThreadId, messagesByThreadId, onChatEvent } = m
  const { tid, trimmed, files, connectContext, proposalId, researchMode, refinement, model, openStream } = p
  const controller = new AbortController()
  const guard = beginSend(sendInFlightRef, { threadId: tid, controller })
  if (!guard) return false
  chatAbortRef.current?.abort()
  chatAbortRef.current = controller
  const markedMessages = markOpenAgentQuestionAnsweredInSnapshot(
    messagesByThreadId[tid] ?? [],
    tid,
    trimmed,
  )
  const turn = prepareSendTurn({ tid, messages: markedMessages, trimmed, files })
  setMessagesByThreadId((prev) =>
    appendInitialSendMessages(prev, { tid, ...turn }),
  )
  startInitialAssistantTurn({
    tid,
    trimmed,
    files,
    signal: controller.signal,
    setMessagesByThreadId,
    connectContext,
    proposalId,
    researchMode,
    refinement,
    model,
    openStream,
    turn,
    sendInFlightRef,
    guard,
    onChatEvent,
  })
  return true
}
